import React, { useEffect, useState, useCallback } from "react";
import { Label } from "reactstrap";
import { MultiSelect } from "react-multi-select-component";
import {
  EMPLOYEE_GET_EMPLOYEE,
  EMPLOYEE_GET_TEAM_EMPLOYEE_INCLUDE,
  GET_EMPLOYEE,
  GET_EMPLOYEES_LIST,
  GET_TEAM_EMPLOYEE_EXCLUDE,
  GET_TEAM_EMPLOYEE_INCLUDE,
} from "../../helpers/url_helper";
import { APIClient } from "../../helpers/api_helper";
import { ToastContainer } from "react-toastify";
const api = new APIClient();
 
const EmployeeSelectAll = ({
  setEmployeeDetails,
  EmployeeDefault,
  setEmployeeDefault,
  teamIndu,
  setSelectedEmployeeOptions,
  setSelectedEmployeeOptions2,
  selectedEmployeeOptions,
  labelContent,
  error,
  setError,
  setEmployeeData,
  setEmployeeDefaultWithoutTeam,
  EmployeeDefaultWithoutTeam
  
}) => {
  const storedValue = JSON.parse(localStorage.getItem("logintype"));
  const permissionType = JSON.parse(localStorage.getItem("permission"));
  const viewReportPermission = permissionType?.includes("VIEW_REPORT");
 
  const fetchEmployeeData = useCallback(async () => {
    try {
      let response;
      if (storedValue === "employee" && permissionType.length > 0) {
        response = await api.get(EMPLOYEE_GET_EMPLOYEE);
      } else if (storedValue === "organization") {
        response = await api.get(GET_EMPLOYEES_LIST);
      }
      if (response?.success === true) {
        const apiResponse = response.data.data;
        const arnOption = (apiResponse || []).map((employee) => ({
          id: `${employee?._id}`,
          value: employee?._id?.trim(),
          label: employee?.fullName?.trim(),
        }));
        setEmployeeDefaultWithoutTeam(arnOption)
        setEmployeeData(arnOption);
        setEmployeeDefault(arnOption);
        // setSelectedEmployeeOptions([]);
        // setSelectedEmployeeOptions2([]);
      }
    } catch (error) {
      console.error("Error fetching employee data:", error);
    }
  }, [storedValue, setEmployeeDefault, setSelectedEmployeeOptions, setSelectedEmployeeOptions2]);


  useEffect(() => {
      fetchEmployeeData();
  }, [teamIndu]);
  
  const handleSelectChange = (selectedOptions) => {
    setSelectedEmployeeOptions(selectedOptions);
    if(setEmployeeDetails)
    setEmployeeDetails(selectedOptions)
  };

  return (
    <>
      <ToastContainer />
      <Label>{labelContent}</Label>
      <MultiSelect
        disabled={
          !viewReportPermission && storedValue === "employee"
            ? true
            : storedValue === "organization"
              ? false
              : false
        }
        options={EmployeeDefault}
        value={selectedEmployeeOptions}
        onChange={handleSelectChange}
        labelledBy={"Select"}
        isCreatable={true}
        overrideStrings={{ selectSomeItems: "Select Employee" }}
        hasSelectAll={true}
        className="classgroup"
      // onMenuToggle={(isOpen) => {
      //   if (isOpen) {
      //     handleFetchEmployeeData();
      //   }
      // }}
      />
      {error && (
        <small
          className="sales-ninja-select-maltipale-lable"
          style={{
            color: "red",
            position: "absolute",
            bottom: "2px",
            left: "22px",
          }}
        >
          <span></span>
          {error}
        </small>
      )}
    </>
  );
};
export default EmployeeSelectAll;